export default {
    header: 'Oops, something unexpected happened',
    text: 'Please restart the page or click on the “Return to Menu” button below.',
    button: 'Return To Menu',
}